module.exports = __webpack_public_path__ + "static/hani-8cee7364a5ce5001be37aadc88525bb7.png";